import { render } from "./PayerInformation.vue?vue&type=template&id=54bd7fe4&ts=true"
import script from "./PayerInformation.ts?vue&type=script&lang=ts&external"
export * from "./PayerInformation.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__